import bus from '~/bus'
import {useEventHelper} from '~/helpers/eventHelper'

export default {
  name: 'deleted',
  do: function (payload) {
    console.log('DEBUG: ', this, payload)
    bus.$emit('refreshTrash')
    const {actorIsSharer} = useEventHelper()
    if (this.file === 'shared') {
      bus.$emit('doBackgroundReload', 'deleted')
    }

    if (this.file === payload.owner) {
      actorIsSharer(payload.owner).then(isSharer => {
        if (!isSharer) {
          bus.$emit('showWarningAndRedirect', 'NoFilesSharedWarning')
        }
      }).catch(e => console.error(e))
    }

    if (this.fileChildren && this.fileChildren.includes(payload.file_id)) {
      bus.$emit('deleteFile', payload.deprecated_file_id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/deleted.js